<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GuqJEk/tc-custom/9781480400757.jpg?1733112902071" alt="This image is the cover for the book Tapestry, The St-Cyr and Kohler Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tapestry, The St-Cyr and Kohler Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A series of interlocking crimes send St-Cyr and Kohler into the heart of the Parisian underworld<br/></b><br/>It is February 1943, and Paris is under a blackout. For three years, the French inspector Jean-Louis St-Cyr and Hermann Kohler of the Gestapo have investigated the mundane violence of Nazi-occupied France, but never have they experienced such a cold, sleeting winter. While investigating a burgled stamp collector’s shop, they get a call telling them that they went to the wrong crime scene—they were supposed to have been sent to comfort a woman who was attacked for running around with Nazis and their collaborators. The rapist’s timing was perfect—so perfect that the two detectives wonder if they were deliberately sent to the wrong place.<br/><br/>They next follow up on a tip about a body dumped in a cellar. The young man they find has been stripped naked, savagely murdered, and left to rot. Was he a homosexual? A pimp? A Resistance fighter? Theft, murder, rape—conspiracy. It is just another night in Paris under the Nazis.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Robert Janes
      </h2>
      
      <p class="authorDescription body article">J. Robert Janes (b. 1935) is a mystery author best known for writing historical thrillers. Born in Toronto, he holds degrees in mining and geology, and worked as an engineer, university professor, and textbook author started he began writing fiction. He began his career as a novelist by writing young adult books, starting with <I>The Odd-Lot Boys and the Tree-Fort War</I> (1976). He wrote his last young adult novel, <I>Murder in the Market</I>, in 1985, by which time he had begun writing for adults, starting with the four-novel Richard Hagen series.<BR /> In 1992, Janes published <I>Mayhem</I>, the first in the long-running St-Cyr and Kohler series, for which he is best known. These police procedurals set in Nazi-occupied France have been praised for the author&rsquo;s attention to historical detail, as well as their swift-moving plots. The thirteenth in the series, <I>Bellringer</I>, was published in 2012.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d43b2de